module.exports = __webpack_public_path__ + "img/lg-oval-1.45f01dfe.png";